<template>
  <div
    :class="[
      'project-list-skeleton',
      variant === 'table-row' && 'project-list-skeleton--table-row'
    ]"
  >
    <template v-if="variant === 'table-row'">
      <div
        v-for="i in rows"
        :key="`tr-${i}`"
        class="skeleton-table-row"
        aria-hidden="true"
      />
    </template>
    <template v-else>
      <div v-for="i in rows" :key="`c-${i}`" class="card mb-3 skeleton-card" aria-hidden="true">
        <div class="card-body skeleton-card__body"></div>
      </div>
    </template>
    <span class="sr-only">{{ label }}</span>
  </div>
</template>

<script>
const VARIANTS = ["card", "table-row"];

export default {
  name: "ProjectListSkeleton",
  props: {
    rows: {
      type: Number,
      default: 10
    },
    /** `card` — карточки как на первичном рынке; `table-row` — плоская строка ~100px без отступов, как старый список «Мои проекты». */
    variant: {
      type: String,
      default: "card",
      validator: (v) => VARIANTS.includes(v)
    },
    label: {
      type: String,
      default: "Загрузка списка предложений"
    }
  }
};
</script>

<style lang="scss">
.project-list-skeleton {
  width: 100%;

  .card .card-body {
    padding: 0.5rem 1.5rem;
  }

  &--table-row {
    .card .card-body {
      padding: 0;
    }
  }
}

@keyframes skeleton-shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}

@mixin skeleton-shimmer-overlay {
  &::after {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 50%;
    background: linear-gradient(
      90deg,
      rgba(241, 242, 244, 0) 0%,
      rgba(231, 232, 235, 0.9) 50%,
      rgba(241, 242, 244, 0) 100%
    );
    animation: skeleton-shimmer 1.25s ease-in-out infinite;
    pointer-events: none;
  }
}

.skeleton-table-row {
  box-sizing: border-box;
  width: 100%;
  height: 100px;
  margin: 0;
  padding: 0;
  position: relative;
  overflow: hidden;
  background: #f1f2f4;

  &:not(:first-child) {
    border-top: 0.125rem solid #ecedef;
  }

  @include skeleton-shimmer-overlay;
}

.skeleton-card {
  width: 100%;
  position: relative;
  overflow: hidden;
  height: 120px;
  background: #f1f2f4;
  border-color: #ecedef;

  .skeleton-card__body {
    height: 5.25rem;
  }

  @media (min-width: 768px) {
    .skeleton-card__body {
      height: 4.75rem;
    }
  }

  @media (min-width: 992px) {
    .skeleton-card__body {
      height: 4.25rem;
    }
  }

  @include skeleton-shimmer-overlay;
}
</style>
